export default __webpack_public_path__ + "static/media/user.5a73c575.svg";